import { IErrosValidacaoDetail, IErroValidacaoTabContent } from '../interfaces/IErroValidacaoDeclaracao';

/**
 * Recebe erros de validação de declaração PLG e Outros Regimes e retorna uma lista de erros formatada
 *
 * @param detail Detalhes dos erros de validação
 * @returns lista de erros formatada,
 *
 */
export function listarErrosValidacao(detail: IErrosValidacaoDetail) {
  const errosValidacaoPLG: string[] = detail?.errosPlg ? detail.errosPlg : [];
  const errosValidacaoOutrosRegimes: string[] = detail?.errosOutrosRegimes ? detail?.errosOutrosRegimes : [];
  const tabNContent: IErroValidacaoTabContent[] = [];
  if (errosValidacaoOutrosRegimes?.length > 0) {
    tabNContent.push({
      tabName: 'Concessão/Licenciamento/Guia de Utilização',
      tabContent: errosValidacaoOutrosRegimes,
    });
  }
  if (errosValidacaoPLG?.length > 0) {
    tabNContent.push({
      tabName: 'Permissão de Lavra Garimpeira',
      tabContent: errosValidacaoPLG,
    });
  }
  return tabNContent;
}
